import { Icon } from "@iconify/react";
import { Button, Stepper } from "../common";
import { useLocalePath } from "../../hooks/useLocalePath";

const AuthOnboardingContainer = ({
  title,
  subtitle,
  totalSteps,
  activedStep,
  icon,
  children,
  stepTitle,
  stepSubtitle,
  onSkip,
  onBack,
  onNext,
  nextLoading,
  nextLabel = "Next",
  /** When false, hide bottom action bar (e.g. entry pages with inline CTAs). */
  showFooter = true,
}) => {
  const lp = useLocalePath();
  return (
    <main className="w-full min-h-screen bg-[#EFF3FF] py-[52px]">
      <div className="w-[83%] mx-auto h-full">
        <div className="flex flex-row">
          <Button
            variant="outline-primary"
            label="Back to Home"
            icon="mdi:arrow-left"
            to={lp("/")}
            className="py-3 px-5 rounded-[10px] font-semibold lg:mx-0 mx-auto lg:mb-0 mb-[50px]"
          />
        </div>
      </div>

      <div className="w-[90%] lg:max-w-[720px] mx-auto h-full flex flex-col items-center justify-center mt-[50px]">
        <div className="bg-white rounded-xl w-full overflow-hidden">
          {/* Header */}
          <div className="p-6 bg-gradient-to-b from-[#F1F5FF] to-[#FFF] border-b border-[#1B51EC1A]">
            <div className="text-dark-blue mb-[22px]">
              <h2 className="text-2xl font-semibold">{title}</h2>
              <p className="mt-2">{subtitle}</p>
            </div>

            <Stepper steps={totalSteps} activedStep={activedStep} />
          </div>

          {/* Content */}
          <div className="w-full flex flex-col items-center py-12 px-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[rgba(27,81,236,0.20)] to-[rgba(37,52,119,0.20)] flex items-center justify-center">
              <Icon icon={icon} className="w-8 h-8 text-primary" />
            </div>

            <div className="mt-4 text-center text-dark-blue mb-6">
              <h3 className="text-[20px] font-semibold">{stepTitle}</h3>
              <p className="mt-1">{stepSubtitle}</p>
            </div>
            {children}
          </div>

          {/* Footer */}
          {showFooter ? (
            <div
              className={`w-full p-6 bg-[#F9FAFB] border-t border-[#2734771A] flex flex-row items-center ${
                onSkip ? "justify-between" : "justify-end"
              }`}
            >
              {onSkip && (
                <Button
                  variant="secondary-blur"
                  label="Skip for now"
                  className="py-2 px-4 rounded-lg"
                  onClick={onSkip}
                />
              )}
              <div className="flex flex-row items-center gap-4">
                {onBack && (
                  <Button
                    variant="secondary-blur"
                    label="Back"
                    icon="mdi:arrow-left"
                    className="py-2 px-4 rounded-lg"
                    onClick={onBack}
                  />
                )}
              <Button
                variant="primary"
                label={nextLabel}
                icon="mdi:arrow-right"
                  iconDirection="right"
                  className="py-2 px-4 rounded-lg"
                  onClick={onNext}
                  loading={nextLoading}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </main>
  );
};

export default AuthOnboardingContainer;
